import { jsx as e } from "react/jsx-runtime";
import { twMerge as n } from "tailwind-merge";
import { TOOLBAR_BUTTON_CLASSNAMES as a } from "../../constants/default-styles.mjs";
function s({ className: r, children: o, ...t }) {
  return /* @__PURE__ */ e(
    "button",
    {
      type: "button",
      className: n(
        a,
        "main-transition-colors",
        t.disabled ? "text-text-secondary" : "text-text-primary hover:text-brand-primary",
        r
      ),
      ...t,
      children: o
    }
  );
}
export {
  s as ToolbarButton
};
